import { ResponseValidateSession } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { ValidateSessionActions } from '../actions';
import { validateSessionTypes } from '../../shared/enums';

export interface ValidateSessionState {
    response: ResponseValidateSession;
    request: {};
    error: any;
}

export const ValidateSessionState: ValidateSessionState = {
    response: null,
    request: null,
    error: null
};

const _validateSessioReducer = createReducer(
    ValidateSessionState,

    on(ValidateSessionActions.getValidateSession, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(ValidateSessionActions.getValidateSessionSuccess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(ValidateSessionActions.getValidateSessionError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(ValidateSessionActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function validateSessionReducer(state, action) {
    if (action.type === validateSessionTypes.VALIDATE_SESSION) {
        state = undefined;
    }
    return _validateSessioReducer(state, action);
}
